import isMobile from 'is-mobile';

export const isMobileDevice = () =>
  isMobile({ tablet: true, featureDetect: true });
